// extracted by mini-css-extract-plugin
export var block = "footer-menu-module--block--1gEb3";
export var menu = "footer-menu-module--menu--1-VZI";
export var menuLink = "footer-menu-module--menuLink--3QBKQ";
export var menuItem = "footer-menu-module--menuItem--354L8";